export const CHABAD_DIGITAL_FONT_OPTIONS = [
  { label: 'Tzlilim', value: 'TzlilimPM', file: 'TzlilimPM-Regular-2.ttf', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Pyutim', value: 'Pyutim', file: 'BA-PYUTIM-REGULAR.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'FrankRuhl', value: 'FrankRuhl', file: 'Frank-Ruhl-Libre.ttf', format: 'truetype', fallback: 'serif' },
  { label: 'FbFrank', value: 'FbFrank', file: 'FbFrankBasic-Medium.otf', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Candara', value: 'Candara', file: 'CANDARA.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Candara Alt', value: 'CandaraAlt', file: 'CANDARA (1).TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Candara Bold', value: 'CandaraBold', file: 'CANDARAB.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Candara Bold Alt', value: 'CandaraBoldAlt', file: 'CANDARAB (1).TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Candara Italic', value: 'CandaraItalic', file: 'CANDARAI.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Candara Light', value: 'CandaraLight', file: 'CANDARAL.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Candara Light Italic', value: 'CandaraLightItalic', file: 'CANDARALI.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Candara Bold Italic', value: 'CandaraBoldItalic', file: 'CANDARAZ.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Myriad Hebrew', value: 'MyriadHebrew', file: 'MYRIADHEBREW-REGULAR.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Hebrew Alt', value: 'MyriadHebrewAlt', file: 'MYRIADHEBREW-REGULAR (1).OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Hebrew Bold', value: 'MyriadHebrewBold', file: 'MYRIADHEBREW-BOLD.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Hebrew Bold Italic', value: 'MyriadHebrewBoldItalic', file: 'MYRIADHEBREW-BOLDIT.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Hebrew Italic', value: 'MyriadHebrewItalic', file: 'MYRIADHEBREW-IT.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'BaFrankNatan', value: 'BaFrankNatan', file: 'BA-FRANKNATAN-DECOR.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'FBavuka', value: 'FBavuka', file: 'FBAVUKA-REGULAR.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'FBmazal', value: 'FBmazal', file: 'FBMAZAL-REGULAR.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'FrankReal', value: 'FrankReal', file: 'FRANKREALREG.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'FrankReTzar', value: 'FrankReTzar', file: 'FRANK-RE-TZAR-REGULAR-AAA.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'NRKis', value: 'NRKis', file: 'nrkis.ttf', format: 'truetype', fallback: 'sans-serif' },
  { label: 'BAHaYetzira', value: 'BAHaYetzira', file: 'BA-HaYetzira-Regular.otf', format: 'opentype', fallback: 'sans-serif' },
  { label: 'BAHaYetzira Bold', value: 'BAHaYetzira-Bold', file: 'BA-HaYetzira-Bold.otf', format: 'opentype', fallback: 'sans-serif' },
  { label: 'BULeshem', value: 'BULeshem', file: 'buLeshem10-Regular.ttf', format: 'truetype', fallback: 'sans-serif' },
  { label: 'BULeshem Bold', value: 'BULeshem-Bold', file: 'buLeshem10-Bold.ttf', format: 'truetype', fallback: 'sans-serif' },
  { label: 'EFTVilna', value: 'EFTVilna', file: 'EFT_Vilna-OT.ttf', format: 'truetype', fallback: 'sans-serif' },
  { label: 'EFTVilna Bold', value: 'EFTVilna-Bold', file: 'EFT_Vilna-BOLD-OT.ttf', format: 'truetype', fallback: 'sans-serif' },
  { label: 'FBShefa', value: 'FBShefa', file: 'FBSHEFA-REGULAR_0.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'FBVilna', value: 'FBVilna', file: 'FBVILNA-REGULAR.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'FBVilna Bold', value: 'FBVilna-Bold', file: 'FBVILNA-BOLD.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Shefa', value: 'Shefa', file: 'SHEFA.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Shefa Bold', value: 'Shefa-Bold', file: 'SHEFABOLD.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Shefa Classic Bold', value: 'ShefaClassicBold', file: 'SHEFACLASSICBOLD.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Light', value: 'MyriadProLight', file: 'FONTSFREE-NET-MYRIADPRO-LIGHT.TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Light Alt', value: 'MyriadProLightAlt', file: 'FONTSFREE-NET-MYRIADPRO-LIGHT (1).TTF', format: 'truetype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Regular', value: 'MyriadProRegular', file: 'MYRIADPRO-REGULAR.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Bold', value: 'MyriadProBold', file: 'MYRIADPRO-BOLD.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Bold Condensed', value: 'MyriadProBoldCond', file: 'MYRIADPRO-BOLDCOND.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Bold Condensed Italic', value: 'MyriadProBoldCondIt', file: 'MYRIADPRO-BOLDCONDIT.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Bold Italic', value: 'MyriadProBoldIt', file: 'MYRIADPRO-BOLDIT.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Condensed', value: 'MyriadProCond', file: 'MYRIADPRO-COND.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Condensed Italic', value: 'MyriadProCondIt', file: 'MYRIADPRO-CONDIT.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Italic', value: 'MyriadProIt', file: 'MYRIADPRO-IT.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro Light Condensed', value: 'MyriadProLightCond', file: 'MYRIADPRO-LIGHTCOND.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro SemiBold', value: 'MyriadProSemiBold', file: 'MYRIADPRO-SEMIBOLD.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro SemiBold Alt', value: 'MyriadProSemiBoldAlt', file: 'MYRIADPRO-SEMIBOLD (1).OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro SemiBold Condensed', value: 'MyriadProSemiBoldCond', file: 'MYRIADPRO-SEMIBOLDCOND.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro SemiBold Italic', value: 'MyriadProSemiBoldIt', file: 'MYRIADPRO-SEMIBOLDIT.OTF', format: 'opentype', fallback: 'sans-serif' },
  { label: 'Myriad Pro SemiBold Italic Alt', value: 'MyriadProSemiBoldItAlt', file: 'MYRIADPRO-SEMIBOLDIT (1).OTF', format: 'opentype', fallback: 'sans-serif' },
];

export const ZMANIM_N_FONT_FAMILY_OPTIONS = CHABAD_DIGITAL_FONT_OPTIONS.map((font) => font.value);
export const QUILL_FONT_FAMILIES = ZMANIM_N_FONT_FAMILY_OPTIONS;

export const TINYMCE_FONT_FAMILY_FORMATS = CHABAD_DIGITAL_FONT_OPTIONS
  .map((font) => `${font.label}=${font.value}`)
  .join('; ');

export const TINYMCE_FONT_FACE_CONTENT_STYLE = CHABAD_DIGITAL_FONT_OPTIONS
  .map(
    (font) =>
      `@font-face { font-family: '${font.value}'; src: url('/fonts/${font.file}') format('${font.format}'); }`
  )
  .join('\n');

const LEGACY_ARTBOARD_FONT_VALUE_OVERRIDES: Record<string, string> = {
  TzlilimPM: 'tzlilim-pm',
  FrankRuhl: 'frank-ruhl-libre',
  Pyutim: 'pyutim',
  NRKis: 'nrkis',
  BAHaYetzira: 'baHaYetzira',
  BULeshem: 'buLeshem',
  EFTVilna: 'eft-vilna',
  'EFTVilna-Bold': 'eft-vilna-bold',
  FBShefa: 'fb-shefa',
  FBVilna: 'fb-vilna',
  'FBVilna-Bold': 'fb-vilna-bold',
  Shefa: 'shefa',
  'Shefa-Bold': 'shefa-bold',
  ShefaClassicBold: 'shefa-classic-bold',
};

export const LEGACY_ARTBOARD_FONT_OPTIONS = CHABAD_DIGITAL_FONT_OPTIONS.map((font) => ({
  label: font.label,
  value:
    LEGACY_ARTBOARD_FONT_VALUE_OVERRIDES[font.value] ||
    font.value
      .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1-$2')
      .toLowerCase(),
  fontFamily: font.value,
}));

export const LEGACY_ARTBOARD_FONT_FAMILY_MAP: Record<string, string> = LEGACY_ARTBOARD_FONT_OPTIONS.reduce(
  (map, font) => ({ ...map, [font.value]: font.fontFamily }),
  {
    'frank-ruhl-libre': 'FrankRuhl',
    'tzlilim-pm': 'TzlilimPM',
    pyutim: 'Pyutim',
    nrkis: 'NRKis',
    baHaYetzira: 'BAHaYetzira',
    buLeshem: 'BULeshem',
    'eft-vilna': 'EFTVilna',
    'eft-vilna-bold': 'EFTVilna-Bold',
    'fb-shefa': 'FBShefa',
    'fb-vilna': 'FBVilna',
    'fb-vilna-bold': 'FBVilna-Bold',
    shefa: 'Shefa',
    'shefa-bold': 'Shefa-Bold',
    'shefa-classic-bold': 'ShefaClassicBold',
  }
);

export function getLegacyArtboardFontFamily(fontKey = '') {
  return LEGACY_ARTBOARD_FONT_FAMILY_MAP[fontKey] || '';
}

export const MINYANIM_TEXT_EDITOR_FONT_OPTIONS = CHABAD_DIGITAL_FONT_OPTIONS.map((font) => ({
  label: font.label,
  value: `${font.value}, ${font.fallback}`,
}));

// Hebrew display fonts shared by the minyanim-roll design cards (List,
// Underline, and Header Grouping fonts). Values are the bare font-family
// names declared in assets/style/index.css.
export const MINYANIM_ROLL_TEXT_FONT_OPTIONS = CHABAD_DIGITAL_FONT_OPTIONS.map((font) => ({
  label: font.label,
  value: font.value,
}));

// The swatches offered beside every colour field in the minyanim-roll design
// cards. Shared so any other design surface (the Yurtzeiten design tab) offers
// the same palette rather than drifting its own copy.
export const MINYANIM_DESIGN_COLOR_OPTIONS = [
  '#111827',
  '#6b7280',
  '#ffffff',
  '#d97706',
  '#c2855b',
  '#92400e',
];

export const MINYANIM_TEXT_EDITOR_ZOOM_OPTIONS = [50, 75, 100, 125, 150, 200];

export const ZMANIM_N_FONT_SIZE_OPTIONS = [
  10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 40, 44, 48,
  56, 64, 72, 80, 88, 96, 110, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300,
];

export const MINYANIM_ROLL_LINE_HEIGHT_OPTIONS = [0.6, 0.7, 0.8, 1, 1.15, 1.25, 1.5, 1.75, 2, 2.5, 3];
